import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getCPDataWithoutParams } from 'src/clinic/services'
import { GenericHeaderBackButton } from 'src/consumer/components/UserActivityPage/MyPlanComponents'
import { GENDER_LIST_OFFLINE } from 'src/consumer/constants'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import MentorHeader from '../MentorHeader'
import LSPastVisitReportsComponent from 'src/consumer/components/LiveSessionPage/components/LSPastVisitReportsComponent/LSPastVisitReportsComponent'

export default function MentorPatientHistoryBasicPage() {
  const { clinicId, patientId } = useParams()
  const navigate = useNavigate()
  const [patientDetails, setPatientDetails] = useState()

  async function getAndSetPatientDetails() {
    const response = await getCPDataWithoutParams(
      `/api/secure/mentor/patient/list?patientId=${patientId}&clinicId=${clinicId}`,
    )
    if (response?.status === 200) {
      setPatientDetails(response?.data?.[0])
    }
  }

  useEffect(() => {
    getAndSetPatientDetails()
  }, [])

  return (
    <>
      <MentorHeader greetingsEnabled={true} />
      <div className='hide-on-print-only' style={{ padding: '20px' }}>
        <GenericHeaderBackButton
          clickfunction={() => navigate('/mentor-home/my-clinic-associations')}
          styles={{ cursor: 'pointer' }}
        />
        <div style={{ marginTop: '20px' }}>
          <b>Patient History</b>
        </div>
        <div>Name: {patientDetails?.name}</div>
        <div>Age: {getAgeFromDobWithTime(patientDetails?.dateOfBirth)}</div>
        <div>
          Gender:{' '}
          {GENDER_LIST_OFFLINE?.find((item) => item?.value === patientDetails?.gender)?.label}
        </div>
      </div>
      <LSPastVisitReportsComponent patientId={patientId} />
    </>
  )
}
